import { usePopper } from "react-popper";
import { FavsDetails } from "./FavsDetails";
import { FavsOpen } from "./FavsOpen";
import { TacticApiClient, ResGetUser, IUserFull } from "@gettactic/api";
import toast from "react-hot-toast";
import { useFavs } from "@gettactic/hooks";
import { useBreakpoint } from "@gettactic/helpers/src/hooks/useBreakpoint";

export interface FavsProps {
  user: ResGetUser | IUserFull;
  size?: "sm" | "md" | "lg";
  api: TacticApiClient;
}

const SIZES = {
  sm: "w-4 h-4 ",
  md: "w-8 h-8 ",
  lg: "w-16 h-16 "
};

export function Favs({ user, size = "sm", api }: FavsProps) {
  // If API is not provided, show a simpler UI without favorites functionality
  if (!api) {
    return (
      <div className="flex min-h-full items-center gap-2">
        <span>{user.name}</span>
      </div>
    );
  }

  const {
    open,
    setOpen,
    setArrowElement,
    setPopperElement,
    referenceElement,
    setReferenceElement,
    hasAnyFav,
    removeUserFromDefaultGroup,
    addUserToDefaultGroup,
    addUserToGroup,
    removeUserFromGroup,
    groups,
    userGroups,
    popperElement,
    arrowElement
  } = useFavs(user, api, () => {
    toast.success("Success");
  });

  const { isBreakpoint } = useBreakpoint();

  const isMd = isBreakpoint("md");

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: !isMd ? "left" : "bottom",
    modifiers: [{ name: "arrow", options: { element: arrowElement } }]
  });
  return (
    <>
      <FavsDetails
        open={open}
        setArrowElement={setArrowElement}
        setOpen={setOpen}
        setPopperElement={setPopperElement}
        styles={styles}
        attributes={attributes}
        referenceElement={referenceElement}
        hasAnyFav={hasAnyFav}
        removeUserFromDefaultGroup={removeUserFromDefaultGroup}
        addUserToDefaultGroup={addUserToDefaultGroup}
        addUserToGroup={addUserToGroup}
        removeUserFromGroup={removeUserFromGroup}
        groups={groups ?? undefined}
        userGroups={userGroups ?? undefined}
        api={api}
      />
      <FavsOpen
        title={
          !hasAnyFav
            ? `Add ${user.name} to your lists`
            : `${user.name} is added to your lists`
        }
        sizeClasses={SIZES[size]}
        hasAnyFav={hasAnyFav}
        setOpen={setOpen}
        open={open}
        setReferenceElement={setReferenceElement}
      />
    </>
  );
}
